import { useState, useContext } from "react";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import { useMutation } from "@apollo/client";
//Import from project
import "../../Style/actionstyle.scss";

import { AuthContext } from "../../Context/AuthContext";
import { DELETE_MEMBER_IN_MANDATE } from "../../Schema/Member";

import RemoveIcon from '@mui/icons-material/Remove';
import DialogDelete from "../../Utils/DialogDelete";
import MemberInMandateForm from "./MemberInMandateForm";
import ResignationForm from "./ResignationForm";


export default function MemberInMandateAction({ editData, setRefetch }) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  //Modal delete
  const [openRes, setOpenRes] = useState(false);
  const handleOpenRes = () => setOpenRes(true);
  const handleCloseRes = () => setOpenRes(false);

  const [deleteMemberInMandate] = useMutation(DELETE_MEMBER_IN_MANDATE, {
    onCompleted: ({ deleteMemberInMandate }) => {
      setLoading(false);
      if (deleteMemberInMandate?.isSuccess === true) {
        setAlert(true, "success", deleteMemberInMandate?.message);
        handleCloseDel();
        setRefetch();

      } else {
        setAlert(true, "error", deleteMemberInMandate?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const handleDelete = () => {
    deleteMemberInMandate({
      variables: {
        id: editData?._id,
      },
    });
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">
      
          <Tooltip title={t("loss")} placement="top">
            <IconButton onClick={handleOpenRes}>
              <Box className="resignation-container">
                <RemoveIcon className="resignation-icon" />
              </Box>
            </IconButton>
          </Tooltip>
      


        {/* {hasPermission(userLogin?.user?.role, "update:user") && ( */}
        <Tooltip title={t("update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        {/* )} */}

        {/* {hasPermission(userLogin?.user?.role, "delete:user") && ( */}
        <Tooltip title={t("delete")} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        {/* )} */}
      </Stack>

      {openRes && (
        <ResignationForm
          open={openRes}
          handleClose={handleCloseRes}
          editData={editData}
          setRefetch={setRefetch}
        />
      )}

      {openEdit && (
        <MemberInMandateForm
          open={openEdit}
          handleClose={handleCloseEdit}
          editData={editData}
          setRefetch={setRefetch}
          dialogTitle="Update"
        />
      )}

      {openDel && (
        <DialogDelete
          open={openDel}
          handleClose={handleCloseDel}
          loading={loading}
          deleteTitle={t("modal_title_delete_member_in_mandate")}
          handleDelete={handleDelete}
          editData={editData}
        />
      )}
    </div>
  );
}
